'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { useBoolean } from '@insta-club/hooks';
import { EducationalPost } from '@insta-club/models';
import { CloseBtn, Dialog } from '@insta-club/ui';
import Image from 'next/image';
import Link from 'next/link';
import CircularPlayButton from '../CircularPlayButton';
import EducationalPostVideo from '../EducationalPostVideo';

function EducationalPostItem({ item }: { item: EducationalPost }) {
    const openVideo = useBoolean();
    return (
        <>
            <div>
                <div
                    onClick={() => {
                        openVideo.onTrue();
                    }}
                    className='relative cursor-pointer overflow-hidden rounded-2xl'
                >
                    <div className='relative aspect-[4/3] h-[250px] w-full'>
                        <Image
                            fill
                            className='object-cover'
                            src={item.thumbnail ?? '/img-not-found-placeholder.jpg'}
                            alt='educational-post'
                            sizes='(max-width: 640px) 100vw, 100vw'
                        />
                    </div>

                    <div
                        className='absolute inset-0 z-[1] flex flex-col items-start justify-between'
                        style={{
                            background:
                                'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 0.01%, rgba(0, 0, 0, 0.656458) 60.92%, rgba(0, 0, 0, 0.8) 95.84%)'
                        }}
                    >
                        <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform'>
                            <CircularPlayButton totalTime={item.time} currentTime={item.watchTime} size={54} />
                        </div>
                    </div>
                </div>
                <Link href={`/videos?coach_id=${item.user.id}`}>
                    <div className='mt-2'>
                        <h4 className='text-sm font-bold text-gray-800'>{item.title}</h4>
                        <div className='m-2 flex items-center'>
                            <Image
                                className='ml-1 h-7 w-7 rounded-full object-cover'
                                width={28}
                                height={28}
                                src={item.user.image ?? '/img-not-found-placeholder.jpg'}
                                alt={'educational-mentor-image'}
                                loading='lazy'
                            />
                            <span className='text-[13px] font-normal text-gray-500'>
                                {item.user.first_name} {item.user.last_name}
                            </span>
                        </div>
                    </div>
                </Link>
            </div>
            <Dialog open={openVideo.value} onClose={openVideo.onFalse}>
                <div className='absolute top-4 left-4 z-50'>
                    <CloseBtn onClick={openVideo.onFalse} />
                </div>
                <EducationalPostVideo
                    item={item}
                    onTimeupdateDelay={(t) => {
                        fetcher(ApiKeys.POST_EDUCATIONAL_POST_SET_DURATION(item.id ?? 0), 'dashboard', 'POST', {
                            body: {
                                duration: t
                            }
                        });
                        // TODO GET VIDEOS NEW LIST
                        // mutate(ApiKeys.GET_APP_HELPS);
                    }}
                    onBack={() => {
                        openVideo.onFalse();
                    }}
                />
            </Dialog>
        </>
    );
}

export default EducationalPostItem;

